/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  monthsArray,
  METERSTOMILES,
  METERSTOKM,
  ROOM_THRESHOLD_1,
  ROOM_THRESHOLD_2,
  RANGE_4_9,
  RANGE_10_25,
  RANGE_26_PLUS,
  MRW_CODE,
  P17_CODE,
  RATE_UNIT,
  RATE_MODE,
  POINTS,
  RateNodeTypeToBeUsed,
  constants,
  hardCodedAllLocale,
  LEISURE_REGION_PIDS_TO_SUPRESS,
} from '../../constants/lib/constants';
import {
  SPECIAL_CODE,
  STATUS_MAPPER,
  RATE_CATEGORY_MAPPER,
  SearchSooSearchDestinationTypes,
  SearchGeographicDestinationTypes,
  SearchWeekType,
  SearchDeviceType,
  SearchBonvoyMemberLevel,
  SearchSooModelType,
  OUTOFSCOPE,
  NOT_AVAILABLE_RECIPE,
  NOT_AVAILABLE,
  CONTROL,
} from '../../organisms/SearchResults/index.constant';
import {
  SearchRateAmountType,
  SearchRateAmountTypeDTT,
  SearchRateType,
  sooOptionsType,
} from '../../organisms/SearchResults/store/store.type';
import { ES_LOCALE, PT_BR_LOCALE, RU_LOCALE, TH_LOCALE } from '../../modules/constants';
import { AEMAlertBodyProps, AlertMessageBodyProps } from '../../organisms/SearchForm/SearchForm.types';
import { capitalize, logger } from '../index';
import {
  AVERAGE_NIGHTLY_RATE_PER_UNIT,
  POINTS_PER_UNIT,
  SUBTOTAL_PER_UNIT,
  ADF_PRODUCT_STATUS_TYPE,
  ADF_IS_FLEXIBLE_PAYLOAD,
} from '../../constants/Calendar.constant';

/**
 * returns the boolean true/false.
 */
const canUseDOM = !!(typeof window !== 'undefined' && window.document);

export function isDateAfterToday(dateString: string): boolean {
  const year = +dateString.substring(0, 4);
  const month = +dateString.substring(5, 7);
  const day = +dateString.substring(8, 10);
  const date = new Date(year, month - 1, day);
  return new Date(date.toDateString()) > new Date(new Date().toDateString());
}

export function getRoomRange(numofRooms: string, roomsList?: { roomQuantity: string }[]): string {
  const numRooms = parseInt(numofRooms);
  const rangeNum = roomsList?.find(item => parseInt(item?.roomQuantity || '1') === parseInt(numofRooms))?.roomQuantity;

  if (numRooms < ROOM_THRESHOLD_1) {
    return numRooms.toString();
  } else if (numRooms < ROOM_THRESHOLD_2) {
    return rangeNum || RANGE_4_9;
  } else if (numRooms <= 25) {
    return rangeNum || RANGE_10_25;
  } else {
    return rangeNum || RANGE_26_PLUS;
  }
}

/*
To convert phone number format for DE & ZH domain
*/
const convertPhoneToDEAndZH = (phoneNumber: string): string => {
  let parts;
  const index = phoneNumber?.indexOf(' ');
  if (index === -1) {
    parts = [phoneNumber, ''];
  }
  parts = [phoneNumber?.slice(0, index), phoneNumber?.slice(index + 1)];

  return parts
    ? parts[0] +
        ' ' +
        parts[1]
          .replaceAll(' ', '')
          .replaceAll('-', '')
          .replace(/(\d{3})(\d{4})/, '$1 $2')
    : '';
};

/*
To format phone number format for DE domain , ZH Domain and US domain
*/ export const formatPhoneNumber = (phoneNumberString: string, lang: string): string => {
  const { log } = logger({})('formatPhoneNumber');
  log.debug(
    `[PerfTesting][SMHotelGalleryTitle] lang:${lang} Entering the formatPhoneNumber function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  let returnedNumber = '';
  switch (lang) {
    case 'de-DE':
    case 'zh-TW':
      log.debug(
        `[PerfTesting][SMHotelGalleryTitle] lang:${lang} Exiting the formatPhoneNumber function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
      );
      returnedNumber = convertPhoneToDEAndZH(phoneNumberString);
      return returnedNumber;
    default:
      if (phoneNumberString?.includes('+')) {
        if (phoneNumberString.replaceAll(' ', '').replaceAll('-', '')?.split('')?.length > 12) {
          returnedNumber = phoneNumberString
            .replaceAll(' ', '')
            .replaceAll('-', '')
            .replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
        } else {
          returnedNumber = phoneNumberString
            .replaceAll(' ', '')
            .replaceAll('-', '')
            .replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2-$3-$4');
        }
      }
      log.debug(
        `[PerfTesting][SMHotelGalleryTitle] lang:${lang} Exiting the formatPhoneNumber function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
      );
      return returnedNumber;
  }
};

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  const { log } = logger({})('formatNumberByLocale');
  log.debug(
    `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  // const str = Number(inputStr).toLocaleString(lang || '');
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  log.debug(
    `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  return str;
};

/**
 * Function creates compact format for a given number based on the locale
 *
 * @param numb | string | undefined
 * @param locale | string
 * @param compactFormatLiteral | any
 * @returns string
 */
export function getCompactFormat(numb: number | string | undefined, locale: string, compactFormatLiteral: any): string {
  if (!numb) return '';
  if (Number(numb) < 1000 && !['ko-KR', 'ja-JP', 'zh-CN', 'zh-TW'].includes(locale)) {
    return numb?.toString();
  }

  const numberLength = Math.trunc(Number(numb)).toString().length;
  const isMillion = !(numberLength > 3 && numberLength < 7);
  let result = '';
  switch (locale) {
    case 'ko-KR':
    case 'ja-JP':
    case 'zh-CN':
    case 'zh-TW':
      result =
        numberLength > 5
          ? // If number is greater than 99,999 then apply the compact number formatting
            numberLength < 8
            ? // If the number is less than 1,00,00,000 then display upto 2 digits after decimal point
              `${Number(Number(numb) / 10000).toLocaleString(locale, { maximumFractionDigits: 2 })}${
                compactFormatLiteral?.tenThousandLabel
              }`
            : // If the number is greater than 99,99,999 then display upto 1 digit after decimal point
              `${Number(Number(numb) / 10000).toLocaleString(locale, { maximumFractionDigits: 1 })}${
                compactFormatLiteral?.tenThousandLabel
              }`
          : // If number is less than or equal to 99,999 then don't apply the compact number formatting
            Number(numb).toLocaleString(locale, { maximumFractionDigits: 1 });
      break;
    case 'en-US':
      result =
        Number(Number(numb) / (isMillion ? 1000000 : 1000)).toLocaleString(locale, { maximumFractionDigits: 1 }) +
        (isMillion ? compactFormatLiteral?.millionLabel : compactFormatLiteral?.thousandLabel);
      break;
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'pt-BR':
    case 'ru-RU':
    case 'ar-AE':
      result =
        Number(Number(numb) / (isMillion ? 1000000 : 1000)).toLocaleString(locale, { maximumFractionDigits: 1 }) +
        ' ' +
        (isMillion ? compactFormatLiteral?.millionLabel : compactFormatLiteral?.thousandLabel);
      break;
    case 'es-ES':
      result =
        Number(Number(numb) / (isMillion ? 1000000 : 1000)).toLocaleString(locale, {
          maximumFractionDigits: 1,
          useGrouping: true,
        }) +
        ' ' +
        (isMillion ? compactFormatLiteral?.millionLabel : compactFormatLiteral?.thousandLabel);
      break;
    default:
      result = numb?.toString();
      break;
  }
  return result;
}

// TODO: Please add code comment explaining what this function does.
export function dateReturner(dateString: string): string {
  const monthIndex = (+dateString.substring(5, 7) - 1).toString();
  const year = +dateString.substring(0, 4);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const monthMapping: any = monthsArray;
  const displayedMonth = monthMapping?.[monthIndex]?.['monthLabel'] ?? '';
  return `${displayedMonth} ${year}`;
}

export function getCalculatedDistance(dist: number | undefined, km: boolean, lang?: string): string | null {
  /** calculated distance for km/ miles */
  if (dist) {
    if (km) {
      // convert meters to km
      return formatNumberByLocale((dist / METERSTOKM).toFixed(1), lang || '');
    } else {
      // convert meters to miles
      return formatNumberByLocale((dist / METERSTOMILES).toFixed(1), lang || '');
    }
  }
  return null;
}

// callback function that will be used by the replace function in getFormattedErrorKey
// used to remove full stops and convert to camel case
function replacer(match: string): string {
  return match?.[1]?.toUpperCase();
}

// function that accepts dot separated string and returns camel cased key
function getFormattedErrorKey(input: string) {
  return input?.toLowerCase()?.replace(/\../g, replacer);
}

export const returnApplicableAlert = (matchKey: string, alertBody: AEMAlertBodyProps[]) => {
  const returnedAlert: any = {};
  const shortlistedAlert =
    alertBody &&
    alertBody?.filter((alert: any) => alert?.alertMsgTypeName?.toLowerCase()?.trim() === matchKey?.toLowerCase())?.[0];
  returnedAlert['alertMessage'] = shortlistedAlert
    ? shortlistedAlert?.alertCodeListModel[0]?.['alertMessageLabel']
    : '';
  returnedAlert['alertCode'] = shortlistedAlert ? shortlistedAlert?.alertMsgTypeName : '';
  returnedAlert['alertType'] = shortlistedAlert ? shortlistedAlert?.alertMsgType : '';
  returnedAlert['linkText'] = shortlistedAlert?.alertCodeListModel?.[0]?.alertLinkText ?? '';
  returnedAlert['messageRedirection'] = shortlistedAlert?.alertCodeListModel?.[0]?.alertMessageRedirection ?? '';
  returnedAlert['messageLink'] = shortlistedAlert?.alertCodeListModel?.[0]?.alertMessageLink ?? '';
  returnedAlert['alertLinkTextLabel'] = shortlistedAlert?.alertCodeListModel?.[0]?.alertLinkTextLabel ?? '';
  returnedAlert['stringNeedsToBeSplit'] = shortlistedAlert
    ? shortlistedAlert?.alertCodeListModel[0]?.['stringNeedsToBeSplit']
    : '';
  return returnedAlert;
};

export function displaySessionBasedAlerts(alertBody: AEMAlertBodyProps[], errorMessageKey: any) {
  let applicableAlert: AlertMessageBodyProps = {};
  let errorKey = '';
  if (errorMessageKey) {
    const sessionErrorKey = errorMessageKey;
    const splitErrorMessages = ('|' + sessionErrorKey)?.split('|');
    errorKey = getFormattedErrorKey(splitErrorMessages[splitErrorMessages?.length - 1] ?? '');
  }
  if (errorKey !== '' || errorKey !== undefined) {
    applicableAlert = returnApplicableAlert(errorKey, alertBody);
    if (applicableAlert && applicableAlert?.alertCode) {
      return applicableAlert;
    }
  }
  return {};
}

export function convertDateToTextFormat(inputDate: string, monthsArray: string[]): string {
  const dateSegments = inputDate.split('-');
  const month = Number(dateSegments[0]);
  const outputDate = monthsArray[month - 1] + ' ' + dateSegments[1] + ' ' + dateSegments[2];
  return outputDate;
}

//accepts rates in bauFormat and returns in DTT format
export const dttRatesTransformer = (rates?: Array<SearchRateType>) => {
  const ratesInDTTFormat = rates?.map((rate: SearchRateType) => {
    //looping though different rate types like stndardrates, points, special rates
    const tempDTTFormatRatesBlock = { ...rate };
    const bauRateCategory = rate?.rateCategory?.type?.code as keyof typeof RATE_CATEGORY_MAPPER;
    tempDTTFormatRatesBlock.rateCategory = {
      //rateCategory format in DTT response
      code: RATE_CATEGORY_MAPPER[bauRateCategory],
      value: rate?.rateCategory?.value,
    };
    const statusCode = rate?.status?.code as keyof typeof STATUS_MAPPER;
    tempDTTFormatRatesBlock.status = {
      //status format in DTT response
      code: STATUS_MAPPER[statusCode],
    };
    //for points and points saver, pointsPerUnit field is required in new DTT format
    if (
      (rate?.rateCategory?.type?.code === SPECIAL_CODE && rate?.rateCategory?.value === MRW_CODE) ||
      (rate?.rateCategory?.type?.code === SPECIAL_CODE && rate?.rateCategory?.value === P17_CODE)
    ) {
      const bauPointsBlock: SearchRateAmountType | undefined = rate?.rateAmounts?.find(
        (rateAmount: SearchRateAmountType) => rateAmount?.rateMode?.code === POINTS_PER_UNIT
      );

      tempDTTFormatRatesBlock.rateModes = {
        pointsPerUnit: {
          //for points and points saver, pointsPerUnit field is required in new DTT format
          points: bauPointsBlock?.points as number,
        },
      };
    }
    //for price, lowestAverageRate field is required in new DTT format
    else {
      const rateModes = { lowestAverageRate: {} }; //for price, lowestAverageRate field is required in new DTT format
      const bauRatesBlock: SearchRateAmountType = rate?.rateAmounts?.find(
        (rateAmount: SearchRateAmountType) => rateAmount?.rateMode?.code === RateNodeTypeToBeUsed
      ) as SearchRateAmountType;

      for (const key in bauRatesBlock) {
        //loop through the cash rate block and convert it to new DTT block
        if (key === RATE_UNIT || key === RATE_MODE || key === POINTS) {
          //These keys are not required in new DTT response
          delete bauRatesBlock[key];
        } else {
          if (bauRatesBlock[key as keyof SearchRateAmountTypeDTT] !== null) {
            // out of the keys fees, taxes, totalAmount, amountPlusMandatioryFees update only available fields
            bauRatesBlock[key as keyof SearchRateAmountTypeDTT] = {
              amount: bauRatesBlock[key as keyof SearchRateAmountTypeDTT]?.origin?.amount,
              currency: bauRatesBlock[key as keyof SearchRateAmountTypeDTT]?.origin?.currency,
              decimalPoint: bauRatesBlock[key as keyof SearchRateAmountTypeDTT]?.origin?.valueDecimalPoint,
            };
          }
        }
      }

      rateModes.lowestAverageRate = { ...bauRatesBlock };
      tempDTTFormatRatesBlock.rateModes = rateModes;
    }
    delete tempDTTFormatRatesBlock.rateAmounts;
    return tempDTTFormatRatesBlock;
  });
  return ratesInDTTFormat;
};

//accepts descriptions in bauFormat and returns in DTT format
export const dttDescriptionTransformer = (descriptions: any) => {
  const descriptionInDTTFormat = descriptions.map(
    (description: { text: string; localizedText?: { translatedText: string } }) => {
      const tempDTTFormatDescriptionBlock = { ...description };
      tempDTTFormatDescriptionBlock.text =
        tempDTTFormatDescriptionBlock?.localizedText?.translatedText ?? tempDTTFormatDescriptionBlock?.text;
      delete tempDTTFormatDescriptionBlock.localizedText;
      return tempDTTFormatDescriptionBlock;
    }
  );
  return descriptionInDTTFormat;
};

export function convertToLowerCase(text: string, locale: string) {
  if (locale === PT_BR_LOCALE) {
    return text?.toLocaleLowerCase();
  } else {
    return text;
  }
}
export function convertToUpperCase(text: string, locale: string) {
  switch (locale) {
    case RU_LOCALE:
      return text?.toLocaleUpperCase();
    case ES_LOCALE:
      return capitalize(text);
    default:
      return text;
  }
}

//Function to get the proper destination type according to the presedence
export function getSearchDestinationTypeAnalytics(destTypes: string[]) {
  const preDefinedOrder = [
    { value: 'street_address', order: 1, label: 'Address' },
    { value: 'subpremise', order: 1, label: 'Address' },
    { value: 'point_of_interest', order: 2, label: 'Point of Interest' },
    { value: 'airport', order: 3, label: 'Airport' },
    { value: 'lodging', order: 4, label: 'Hotel Name' },
    { value: 'neighborhood', order: 5, label: 'Neighborhood' },
    { value: 'sublocality_level_1', order: 6, label: 'Borough' },
    { value: 'administrative_area_level_3', order: 6, label: 'Borough' },
    { value: 'locality', order: 7, label: 'City' },
    { value: 'administrative_area_level_2', order: 8, label: 'County' },
    { value: 'administrative_area_level_1', order: 9, label: 'State_Province_Region' },
    { value: 'colloquial_area', order: 10, label: 'Leisure Region' },
    { value: 'continent', order: 10, label: 'Leisure Region' },
    { value: 'country', order: 11, label: 'Country' },
  ];
  for (let i = 0; i < destTypes?.length; i++) {
    const matchedItem = preDefinedOrder?.find(item => item.value === destTypes[i]);
    if (matchedItem) {
      return matchedItem?.label;
    }
  }
  return 'NA';
}

export interface SuggestedPlaceDetailsForType {
  destinationType?: string;
  types?: string[];
  placeId?: string | null;
  location?: {
    latitude?: number | string | null;
    longitude?: number | string | null;
    state?: string;
    country?: string;
  };
}

export const resolveDestinationType = (
  suggestedPlaceDetails: SuggestedPlaceDetailsForType | null | undefined,
  getDestinationTypeFlag: string | boolean = false
): string => {
  const isFlagEnabled = getDestinationTypeFlag === 'true' || getDestinationTypeFlag === true;
  const placeTypes: string[] = suggestedPlaceDetails?.types ?? [];
  const destinationType = isFlagEnabled
    ? suggestedPlaceDetails?.destinationType ?? ''
    : getSearchDestinationTypeAnalytics(placeTypes);

  // For "Leisure Region", keep as-is when placeId is in the suppress list;
  // otherwise remap based on available location fields:
  //   lat/lng -> City, state -> State, country-only -> Country.
  if (destinationType === SearchGeographicDestinationTypes.Leisure_Region) {
    const placeId = suggestedPlaceDetails?.placeId;
    if (placeId && LEISURE_REGION_PIDS_TO_SUPRESS.includes(placeId)) {
      return SearchGeographicDestinationTypes.Leisure_Region;
    } else {
      return 'City';
    }
  }

  return destinationType;
};

/**
 * Retrieves the user's country code from Akamai's browser location data if available.
 * Returns the default country code if the data is not available or the DOM is not accessible.
 *
 * @returns {string} - The user's country code (in uppercase) or the default country code.
 */
export function getUserCountryCodeFromAkamai(): string {
  if (!canUseDOM) {
    return constants.DEFAULT_COUNTRY.toUpperCase();
  }

  const countryCode =
    (window?.dataLayer?.['browser_akamai_loc_country'] as unknown as string) ?? constants.DEFAULT_COUNTRY;
  return countryCode.toUpperCase();
}

export const checkLocaleToAddYears = (currentLocale: string, year: number): number => {
  switch (currentLocale) {
    case TH_LOCALE:
      return Number(year + 543);
    default:
      return year;
  }
};

export const modifyDateStringForThai = (dateString: string): string => {
  let modifiedDateString = '';
  let i = 0;

  while (i < dateString.length) {
    // Check if the current character is a numeric digit
    if (dateString[i] >= '0' && dateString[i] <= '9') {
      // Found the start of a sequence of numeric digits
      const start = i;
      const end = i + 3;

      // Ensure we have at least 4 characters left in the string
      if (end < dateString.length && dateString[end] >= '0' && dateString[end] <= '9') {
        // Extract the 4 consecutive numeric digits
        const numericDigits = dateString.slice(start, end + 1);

        // Convert the numeric string to a number, add the given value
        const newValue = parseInt(numericDigits) + 543;

        // Append the modified numeric value to the result string
        modifiedDateString += newValue.toString();

        // Move the index past the 4 consecutive numeric digits
        i = end + 1;
      } else {
        // If not enough characters left, just append the current character
        modifiedDateString += dateString[i];
        i++;
      }
    } else {
      // Append non-numeric characters directly to the result string
      modifiedDateString += dateString[i];
      i++;
    }
  }

  return modifiedDateString;
};

// Function to apply text transformations to room text
export const transformRoomText = (roomText: string | undefined, currentLocale: string) => {
  let transformedRoomText = roomText;
  switch (currentLocale) {
    case 'es-ES':
      transformedRoomText = roomText?.toLowerCase();
      break;
  }
  return transformedRoomText;
};

// Function to apply text transformations to guest text
export const transformGuestText = (guestText: string | undefined, currentLocale: string) => {
  let transformedGuestText = guestText ? capitalize(guestText) : guestText;
  switch (currentLocale) {
    case 'es-ES':
      transformedGuestText = guestText?.toLowerCase();
      break;
    case 'pl-PL':
      transformedGuestText = guestText?.toLowerCase();
      break;
  }
  return transformedGuestText;
};

export const mapRoomCountForMeetingsAndEventsRecentSearches = (
  recentSearches: any,
  roomsList?: { roomQuantity: string }[]
) => {
  recentSearches.forEach((recentSearchEntry: any) => {
    recentSearchEntry.guestRooms = getRoomRange(recentSearchEntry.guestRooms, roomsList);
  });
};

export const mapGuestsCountForMeetingsAndEventsRecentSearches = (recentSearches: Record<string, string>[]) => {
  recentSearches.forEach((recentSearchEntry: Record<string, string>) => {
    recentSearchEntry['attendees'] = recentSearchEntry['attendees'] || '0';
  });
};

export const filterRecentSearchesEntries = (recentSearches: Record<string, string>[], isMeetingDestField?: boolean) => {
  return recentSearches.filter((recentSearchEntry: Record<string, string>) => {
    if (recentSearchEntry['eventType'] || recentSearchEntry['guestRooms'] || recentSearchEntry['attendees']) {
      return isMeetingDestField ? true : false;
    } else {
      return isMeetingDestField ? false : true;
    }
  });
};

//Function to map the Bonvoy Member level value for Ellite users
export function getBonvoyMemberLevel(memState: string, memberLevel: string, memberLevelAbbr: string) {
  if (memState === 'unauthenticated') {
    return SearchBonvoyMemberLevel.ANONYMOUS;
  } else if (memState === 'authenticated') {
    if (memberLevel?.toUpperCase() === 'P' && memberLevelAbbr) {
      switch (memberLevelAbbr?.toUpperCase()) {
        case 'PAC':
        case 'PAR':
        case 'PLR':
          return SearchBonvoyMemberLevel.PLATINUM;
        case 'PPR':
          return SearchBonvoyMemberLevel.PLATINUM_PREMIERE;
        case 'PFS':
        case 'PFR':
          return SearchBonvoyMemberLevel.AMBASSADOR;
        default:
          return SearchBonvoyMemberLevel.TITANIUM;
      }
    } else if (memberLevel?.toUpperCase() === 'R') {
      return SearchBonvoyMemberLevel.BASIC;
    } else if (memberLevel?.toUpperCase() === 'G') {
      return SearchBonvoyMemberLevel.GOLD;
    } else if (memberLevel?.toUpperCase() === 'S') {
      return SearchBonvoyMemberLevel.SILVER;
    } else {
      return '';
    }
  } else {
    return '';
  }
}

//Function to map the device type for UXL queries
export function getDeviceType() {
  if (typeof window !== 'undefined' && window?.screen && window?.screen?.width) {
    return window.innerWidth > 992 ? SearchDeviceType.DESKTOP_WEB : SearchDeviceType.MOBILE_WEB;
  } else {
    return undefined;
  }
}

//Function to map the sooModel type for UXL queries
export function getSooModel(val: string) {
  if (!val) {
    return SearchSooModelType.OUT_OF_SCOPE;
  } else {
    return val;
  }
}

//Function to map the week type for UXL queries
export function getWeekType(val: string) {
  switch (val) {
    case 'Weekdays Only':
      return SearchWeekType.WEEKDAYS_ONLY;
    case 'Weekend Only':
      return SearchWeekType.WEEKEND_ONLY;
    case 'Weekday and Weekend Stay':
      return SearchWeekType.WEEKDAY_AND_WEEKEND_STAY;
    default:
      return '';
  }
}

//Function to map the Search Destination Type for UXL queries
export function getSearchDestinationType(val: string) {
  switch (val) {
    case 'Address':
      return SearchSooSearchDestinationTypes.ADDRESS;
    case 'Point of Interest':
      return SearchSooSearchDestinationTypes.POINT_OF_INTEREST;
    case 'Airport':
      return SearchSooSearchDestinationTypes.AIRPORT;
    case 'Hotel Name':
      return SearchSooSearchDestinationTypes.HOTEL_NAME;
    case 'Neighborhood':
      return SearchSooSearchDestinationTypes.NEIGHBORHOOD;
    case 'Borough':
      return SearchSooSearchDestinationTypes.BOROUGH;
    case 'City':
      return SearchSooSearchDestinationTypes.CITY;
    case 'County':
      return SearchSooSearchDestinationTypes.COUNTY;
    case 'State_Province_Region':
      return SearchSooSearchDestinationTypes.STATE;
    case 'Leisure Region':
      return SearchSooSearchDestinationTypes.LEISURE_REGION;
    case 'Country':
      return SearchSooSearchDestinationTypes.COUNTRY;
    default:
      return SearchSooSearchDestinationTypes.OTHERS;
  }
}

//Function to check to whether pass soo field in the query or not
export const checkSooOptionsField = (
  currentLocale: string,
  isFlexibleDateSearch: boolean,
  isSOOEnabled: boolean,
  sooOptions?: sooOptionsType
) => {
  return Object.keys(sooOptions ?? {}).length > 0 &&
    !isFlexibleDateSearch &&
    currentLocale === hardCodedAllLocale.en &&
    isSOOEnabled
    ? true
    : false;
};

//Function to map the recipe Id with the proper SOO Model
export function getRecipeId(sooModel?: string, recipeID?: string, isFlexibleDateSearch?: boolean) {
  if (sooModel === SearchSooModelType.OUT_OF_SCOPE) {
    return `${OUTOFSCOPE}${NOT_AVAILABLE_RECIPE}`;
  } else {
    if (recipeID === null || recipeID === NOT_AVAILABLE || isFlexibleDateSearch) {
      return `${sooModel}${NOT_AVAILABLE_RECIPE}`;
    } else {
      return recipeID;
    }
  }
}

// Function to get os info
export const getOSInformation = () => {
  if (typeof navigator === 'undefined') {
    return 'other';
  }

  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  } else if (/android/.test(userAgent)) {
    return 'android';
  } else {
    return 'other';
  }
};

export const isRecommendedSortSegmentId = (segmentId: string | undefined) => {
  if (!segmentId || segmentId === CONTROL) {
    return false;
  }
  return true;
};

/**
 * Font string used for measuring text width in search form input fields.
 * This matches the font styling used in the inactive state of search form fields.
 */
export const SEARCH_FORM_INPUT_FONT = '500 16px Swiss-721, sans-serif';

/**
 * Checks if a font is loaded and available for use.
 * @param font - CSS font string to check
 * @returns true if the font is loaded
 */
const isFontLoaded = (font: string): boolean => {
  if (typeof document === 'undefined' || !document.fonts?.check) return false;
  try {
    return document.fonts.check(font);
  } catch {
    return false;
  }
};

/**
 * Measures the actual pixel width of text using a hidden DOM element.
 * This provides accurate width measurement for proportional fonts where
 * character widths vary (unlike `ch` units which assume monospace-like width).
 *
 * Uses DOM-based measurement instead of Canvas to ensure the actual rendered
 * font is used (Canvas may not have access to custom web fonts).
 *
 * @param text - The text string to measure
 * @param font - CSS font string (defaults to SEARCH_FORM_INPUT_FONT)
 * @returns The width in pixels
 */
export const measureTextWidth = (text: string, font: string = SEARCH_FORM_INPUT_FONT): number => {
  if (typeof document === 'undefined') return text.length * 10;

  // If the custom font isn't loaded yet, use a conservative estimate
  // This prevents the width from being too wide when fallback font is used
  if (!isFontLoaded(font)) {
    // Approximate width based on average character width for the target font
    // Swiss-721 at 16px has roughly 8px average character width
    return text.length * 8;
  }

  try {
    const span = document.createElement('span');
    span.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font: ${font};
      left: -9999px;
    `;
    span.textContent = text;
    document.body.appendChild(span);
    const width = span.getBoundingClientRect().width;
    document.body.removeChild(span);
    return width;
  } catch {
    return text.length * 10;
  }
};

/**
 * Touchmove handler reference for iOS scroll lock.
 * Stored at module level so it can be removed on unlock.
 */
let _scrollLockTouchMoveHandler: ((e: TouchEvent) => void) | null = null;

/**
 * Flag that can be checked synchronously to determine if body scroll is locked.
 * Useful for scroll handlers that need to bail out immediately.
 */
export let isBodyScrollLocked = false;

/**
 * Locks body scrolling in an iOS-compatible way.
 * Stores current scroll position in body.dataset.scrollY and applies position:fixed
 * to prevent background scrolling when a modal/overlay is open.
 *
 * On iOS Safari, position:fixed alone does not prevent pull-to-refresh or
 * rubber-band bounce. We additionally block touchmove on the document and
 * apply overscroll-behavior to disable native pull-to-refresh.
 */
export const lockBodyScroll = (): void => {
  if (typeof document === 'undefined') return;

  isBodyScrollLocked = true;

  const body = document.body;
  const scrollY = window.scrollY;

  body.dataset['scrollY'] = scrollY.toString();
  body.style.setProperty('position', 'fixed', 'important');
  body.style.setProperty('top', `-${scrollY}px`, 'important');
  body.style.setProperty('left', '0', 'important');
  body.style.setProperty('right', '0', 'important');
  body.style.setProperty('width', '100%', 'important');
  body.style.setProperty('overflow', 'hidden', 'important');
  body.style.setProperty('touch-action', 'none', 'important');
  body.style.setProperty('overscroll-behavior', 'none', 'important');

  // Prevent touchmove on areas outside scrollable modal content.
  // Allow scrolling inside elements that have their own scrollable area.
  _scrollLockTouchMoveHandler = (e: TouchEvent) => {
    let target = e.target as HTMLElement | null;
    while (target && target !== body) {
      const style = window.getComputedStyle(target);
      const isScrollableY = style.overflowY === 'auto' || style.overflowY === 'scroll';
      const isScrollableX = style.overflowX === 'auto' || style.overflowX === 'scroll';
      const hasOverflowY = target.scrollHeight > target.clientHeight;
      const hasOverflowX = target.scrollWidth > target.clientWidth;
      if ((isScrollableY && hasOverflowY) || (isScrollableX && hasOverflowX)) {
        return;
      }
      target = target.parentElement;
    }
    e.preventDefault();
  };

  document.addEventListener('touchmove', _scrollLockTouchMoveHandler, { passive: false });
};

/**
 * Unlocks body scrolling, restoring the scroll position that was saved by lockBodyScroll.
 */
export const unlockBodyScroll = (): void => {
  if (typeof document === 'undefined') return;

  isBodyScrollLocked = false;

  const body = document.body;
  const storedScrollY = parseInt(body.dataset['scrollY'] || '0', 10);

  body.style.removeProperty('position');
  body.style.removeProperty('top');
  body.style.removeProperty('left');
  body.style.removeProperty('right');
  body.style.removeProperty('width');
  body.style.removeProperty('overflow');
  body.style.removeProperty('touch-action');
  body.style.removeProperty('overscroll-behavior');
  delete body.dataset['scrollY'];

  if (_scrollLockTouchMoveHandler) {
    document.removeEventListener('touchmove', _scrollLockTouchMoveHandler);
    _scrollLockTouchMoveHandler = null;
  }

  window.scrollTo(0, storedScrollY);
};
